import { createContext, useContext, useState, useEffect } from "react";
import axiosClient from "../axios-client";
const StateContext = createContext({
  currentUser: null,
  token: null,
  notification: null,
  setUser: () => { },
  setToken: () => { },
  setIsLoading: () => { },
  countTickets: () => { },
  count: () => { },
  countNotes: () => { },
  getAbonnementClient: () => { },
  currentBusiness: null,
  setCurrentBusiness: () => { },
});

export const ContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [token, _setToken] = useState(localStorage.getItem("ACCESS_TOKEN"));
  const [countTickets, setCountTickets] = useState();
  const [countTicketsManager, setCountTicketsManager] = useState();
  const [countTicketsAdmin, setCountTicketsAdmin] = useState();
  const [countTicketsManagerAdmin, setCountTicketsManagerAdmin] = useState();
  const [count, setCount] = useState('')
  const [countNotes, setCountNotes] = useState('')
  const [dataSubscriptionUser, setDataSubscriptionUser] = useState({});

  // ── Active business workspace ─────────────────────────────────────────────
  const [currentBusiness, _setCurrentBusiness] = useState(() => {
    try {
      const stored = localStorage.getItem("CURRENT_BUSINESS");
      return stored ? JSON.parse(stored) : null;
    } catch { return null; }
  });

  const setCurrentBusiness = (biz) => {
    _setCurrentBusiness(biz);
    if (biz) {
      localStorage.setItem("CURRENT_BUSINESS", JSON.stringify(biz));
    } else {
      localStorage.removeItem("CURRENT_BUSINESS");
    }
  };

  //const [notification, _setNotification] = useState('');
  const [isLoading, _setIsLoading] = useState(false);

  useEffect(() => {
    let activeRequests = 0;

    const requestInterceptor = axiosClient.interceptors.request.use((config) => {
      activeRequests++;
      _setIsLoading(true);
      return config;
    });

    const responseInterceptor = axiosClient.interceptors.response.use(
      (response) => {
        activeRequests--;
        if (activeRequests === 0) {
          _setIsLoading(false);
        }
        return response;
      },
      (error) => {
        activeRequests--;
        if (activeRequests === 0) {
          _setIsLoading(false);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosClient.interceptors.request.eject(requestInterceptor);
      axiosClient.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {

    if (token) {
      axiosClient
        .get("auth/user/")
        .then(({ data }) => {
          setUser(data);
          try {
            axiosClient.get(`/check-subscription-status/?client=${data.id}`)
              .then((res) => {
                if (new Date(res.data.end_date) === new Date(res.data.current_time)) {
                  axiosClient.post(`cancel-subscription/?client=${data.id}`)
                  setDataSubscriptionUser({});
                  return;
                } else {
                  setDataSubscriptionUser(res.data);
                }

              })
              .catch((error) => {
                // // console.error(error);
              });
          } catch (error) {
            // // console.error('Error checking subscription status:', error);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  }, [token]);

  const setToken = (token, refreshToken = null) => {
    _setToken(token);
    if (token) {
      localStorage.setItem("ACCESS_TOKEN", token);
      if (refreshToken) {
        localStorage.setItem("REFRESH_TOKEN", refreshToken);
      }
    } else {
      localStorage.removeItem("ACCESS_TOKEN");
      localStorage.removeItem("REFRESH_TOKEN");
      // Clear business selection on logout
      setCurrentBusiness(null);
    }
  };

  const setIsLoading = (v) => {
    _setIsLoading(v);
  };

  function updateUser() {
    axiosClient
      .get("auth/user/")
      .then(({ data }) => {
        setUser(data);
        // console.log(data);

      })
      .catch((err) => {
        // console.log(err);
      });
  }

  function updateTicketCount() {
    if (!user?.id) return;
    axiosClient.get(`/tickets/getTotalTicketsCount/?user=${user.id}`)
      .then((res) => {
        setCountTickets(res.data.total_count_admin);
        setCountTicketsManager(res.data.total_count_manager);
      })
      .catch((error) => {
        // // console.error(error);
      });
  }
  function updateTicketCountAdmin() {
    axiosClient.get(`/tickets/getTotalTicketsCount/`)
      .then((res) => {
        setCountTicketsAdmin(res.data.total_count_admin);
        setCountTicketsManagerAdmin(res.data.total_count_manager);
      })
      .catch((error) => {
        // // console.error(error);
      });
  }

  const getAbonnementClient = async () => {
    try {
      const response = await axiosClient.get(`/check-subscription-status/?client=${user?.id}`);
      if (response.data.status === "error") {
        setDataSubscriptionUser({});
        return;
      } else if (new Date(response.data.end_date) === new Date(response.data.current_time)) {
        axiosClient.post(`cancel-subscription/?client=${user?.id}`)
        setDataSubscriptionUser({});
        return;
      }
      else {
        setDataSubscriptionUser(response.data)
      }
    } catch (error) {
      // // console.error('Error fetching subscription data:', error);
    }
  }


  return (
    <StateContext.Provider
      value={{

        user,
        setUser,
        token,
        setToken,
        setIsLoading,
        isLoading,
        countTickets,
        countTicketsManager,
        setCountTickets,
        setCountTicketsManager,
        count,
        setCount,
        countNotes,
        setCountNotes,
        updateUser,
        updateTicketCount,
        updateTicketCountAdmin,
        dataSubscriptionUser,
        getAbonnementClient,
        currentBusiness,
        setCurrentBusiness,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};
export const useStateContext = () => useContext(StateContext);
